import React, { useEffect, useState, useRef, useCallback } from 'react'
import { useRouter } from 'next/router'
import LocationSearch from '../../components/hero/hero-rslhome/FromTo'
import Location from '../../components/hero/hero-rslhome/AddressBookRideActivities'
import CarSideBar from '../../components/flights/BookingSidebar/TourSideBar'
import HotelDestinationCountry from '../../components/hero/hero-rslhome/TourDestinationCountryHoliday'
import HotelCalanderFrom from '../../components/hero/hero-rslhome/TourCalanderFromHoliday'
import GuestSearch from '../../components/rental-list/common/GuestSearchHoliday'
// import HotelDestinationCity from '../../components/hero/hero-rslhome/TourDestinationCityHoliday';
import HotelDestinationCity from '../../components/hero/hero-rslhome/staycation/ActivityDestinationCityStaycation'
import ActivityListStaycation from '../../components/hero/hero-rslhome/staycation/ActivityListStaycation'
import Footer3 from '../../components/footer/footer-3'
import Header3 from '../../components/header/header-rslhome'
import Hero3 from '../../components/common/listServiceBannerImage'
import Image from 'next/image'
import Rating from '@mui/material/Rating'
import isTextMatched from '../../utils/isTextMatched'
import { styled } from '@mui/material/styles'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Navigation, Pagination } from 'swiper'
import CircularProgress from '@mui/material/CircularProgress'
import Skeleton from '@mui/material/Skeleton'

// Redux
import { useDispatch, useSelector } from '../../redux/store'
import {
  getStaycationListNew,
  searchStaycation,
  searchStaycationList,
  searchStaycationFilter
} from '../../redux/slices/staycation'

import moment from 'moment'
import Head from 'next/head'
import CallMadeIcon from '@mui/icons-material/CallMade'
import { Box } from '@mui/material'
import Seo from '../../components/common/Seo'
import { fetchSeoByPage } from '../../lib/seoHelper'

const HolidaysBooking = ({ meta }) => {
  const dispatch = useDispatch()
  const router = useRouter()
  const autocompleteFirst = useRef()
  const autocompleteNext = useRef()
  const [guestSearch, setGuestSearch] = useState('2')
  const {
    country,
    city,
    cityName,
    productId,
    name,
    checkIn,
    checkOut,
    adult,
    child,
    rooms
  } = router.query

  const {
    stayCationListNew,
    staycationSearchRes,
    staycationSearchListRes,
    staycationSearchFilterRes
  } = useSelector(state => state.staycation)

  const currentPath = router.asPath

  const [openBookNow, setOpenBookNow] = useState(false)
  const [fullWidth, setFullWidth] = useState(true)
  const [isOffcanvasOpen, setIsOffcanvasOpen] = useState(false)
  const [pickUpLocat, setPickUpLocat] = useState('')
  const [dropOffLocation, setDropOffLocation] = useState('')
  const [distance, setDistance] = useState('')
  const [countryValue, setCountryValue] = useState('')
  const [cityValue, setCityValue] = useState([])
  const [searchProduct, setSearchProduct] = useState('')
  const [selectedValue, setSelectedValue] = useState({
    name: ''
  })
  const [cityValue1, setCityValue1] = useState([])
  const [searchProduct1, setSearchProduct1] = useState([])
  const [selectedValue1, setSelectedValue1] = useState({
    name: '',
    _id: ''
  })
  const [holidayListData, setHolidayListData] = useState([])
  const [checkInDate, setCheckInDate] = useState('')
  const [checkOutDate, setCheckOutDate] = useState('')
  const [activityType, setActivityType] = useState([])
  const [filterData, setFilterData] = useState([])
  const [sortData, setSortData] = useState(0)
  const [priceData, setPriceData] = useState({
    min: 0,
    max: 0
  })
  const [priceData1, setPriceData1] = useState({
    min: 0,
    max: 0
  })
  const [priceValue, setPriceValue] = useState(0)
  const [guetsValue, setGuestValue] = useState({
    Adults: 1,
    Children: 0,
    Rooms: 1
  })
  const [userId, setUserId] = useState('')
  const [click, setClick] = useState(false)
  const [loader, setLoder] = useState(true)
  const [currentButton, setCurrentButton] = useState(null)
  const [isFetching, setIsFetching] = useState(false) // ✅ Prevent multiple calls
  const [filterDataOne, setFilterDataOne] = useState({
    cityName: '',
    departDate: '',
    returnDate: '',
    priceRange: {
      min: 0,
      max: 0
    }
  });
  const scrollableDivRef = useRef(null);
  const [singleDate, setSingleDate] = useState(moment().format('YYYY-MM-DD'))

  const [isPriceChange, setIsPriceChange] = useState(false)
  const [loading, setLoading] = useState(true)
  const [cityLoading, setCityLoading] = useState(false)
  const [isFilter, setIsFilter] = useState(false)
  const [currency, setCurrency] = useState('')

  const [focusNext, setFocusNext] = useState(false)

  const [paginationData, setPaginationData] = useState({
    page: 1,
    limit: 10
  })

  // useEffect(() => {
  //   if (autocompleteFirst.current) {
  //     autocompleteFirst.current.querySelector('input').focus();
  //   }
  // }, []);

  const [activeSort, setActiveSort] = useState('FEATURED')
  const [sortOrder, setSortOrder] = useState('asc')
  const observerRef = useRef(null)

  const activityTypeRef = useRef(activityType) // ✅ Store the latest state

  useEffect(() => {
    activityTypeRef.current = activityType // ✅ Always update the ref when activityType changes
  }, [activityType])

  // Pagination start

  const lastItemRef = useCallback(
    node => {
      if (isFetching || paginationData.page >= stayCationListNew?.totalPages)
        return

      if (observerRef.current) observerRef.current.disconnect()

      observerRef.current = new IntersectionObserver(
        entries => {
          if (entries[0].isIntersecting) {
            handleLastItem()
          }
        },
        { threshold: 1.0 }
      )

      if (node) observerRef.current.observe(node)
    },
    [
      isFetching,
      paginationData.page,
      stayCationListNew?.totalPages,
      selectedValue
    ]
  )

  useEffect(() => {
    return () => observerRef.current?.disconnect() // Cleanup on unmount
  }, [])

  const sortDataRef = useRef(sortData)

  useEffect(() => {
    sortDataRef.current = sortData
  }, [sortData])



  const handleLastItem = () => {
    if (isFetching) return
    setIsFetching(true)

    setPaginationData(prev => {
      const updatedPage = prev.page + 1 // ✅ Ensure it always increments

      // ✅ Return new paginationData state
      return { ...prev, page: updatedPage }
    })

    setTimeout(() => {
      setPaginationData(prev => {
        const obj = {
          StayCationId: selectedValue1?._id,
          cityName: selectedValue?.name,
          // name: selectedValue?.name,
          departDate: checkIn ? checkIn : '',
          returnDate: checkOut ? checkOut : '',
          priceRange: priceData,
          sort: sortDataRef.current,
          filter: activityTypeRef?.current,
          page: prev.page, // ✅ Now using the correctly updated page
          limit: prev.limit,
        }
        dispatch(getStaycationListNew(obj))

        return prev
      })

      // setIsFetching(false);
    }, 0) // ✅ Allow state update to complete
  }

  useEffect(() => {
    if (!lastItemRef.current) return // ✅ Ensure ref exists before observing

    const observer = new IntersectionObserver(
      entries => {
        if (entries[0].isIntersecting) {
          handleLastItem() // Call your function
        }
      },
      { threshold: 1.0 } // Trigger when 100% visible
    )

    observer.observe(lastItemRef.current)

    return () => observer.disconnect()
  }, [lastItemRef.current, holidayListData])

  // Pagination end

  const handleSortChange = type => {
    const newSortOrder =
      activeSort === type && sortOrder === 'asc' ? 'desc' : 'asc'
    setActiveSort(type)
    setSortOrder(newSortOrder)
    setIsPriceChange(true);
    if (type === "RATING") {
      setSortData(newSortOrder === 'desc' ? 8 : 2)
    } else {
      setSortData(newSortOrder === 'desc' ? 7 : 3)
    }
    // const sortedList = [...holidayListData].sort((a, b) => {
    //   if (type === 'PRICE') {
    //     return newSortOrder === 'asc' ? a.price - b.price : b.price - a.price
    //   } else if (type === 'RATING') {
    //     const ratingA = parseFloat(a.rating)
    //     const ratingB = parseFloat(b.rating)
    //     return newSortOrder === 'asc' ? ratingA - ratingB : ratingB - ratingA
    //   }

    //   return 0
    // })
    // setHolidayListData(sortedList)
  }

  useEffect(() => {
    setLoading(true)
    setCityLoading(true)
    // dispatch(searchStaycation({ query: searchProduct }));
    const timerId = setTimeout(() => {
      if (searchProduct.length >= 3) {
        setCityValue([])
        dispatch(
          searchStaycation({
            query: searchProduct.length > 0 ? searchProduct : ''
          })
        )
      } else if (searchProduct.length === 0) {
        dispatch(searchStaycation({ query: '' }))
      }
    }, 1000)

    return () => {
      clearTimeout(timerId)
    }
  }, [searchProduct])

  useEffect(() => {
    if (staycationSearchFilterRes) {
      setFilterData(staycationSearchFilterRes?.filterData)
      const obj = {
        min: staycationSearchFilterRes?.priceRange?.startingPrice,
        max: staycationSearchFilterRes?.priceRange?.endingPrice
      }
      setCurrency(staycationSearchFilterRes?.currency)
      // setPriceData(obj)
      // setPriceData1(obj)
    }
  }, [staycationSearchFilterRes])

  useEffect(() => {
    const obj = {
      StayCationId: productId,
      cityName: cityName ? cityName : 'United Arab Emirates',
      // name: name ? name : '',
      departDate: checkIn ? checkIn : '',
      returnDate: checkOut ? checkOut : '',
      priceRange: priceData,
      filter: activityType
    }
    dispatch(searchStaycationFilter(obj))
    // dispatch(getServiceBannerList({ type: 4 }));
  }, [])

  useEffect(() => {
    setLoading(true)
    setCityLoading(true)
    const timerId = setTimeout(() => {
      if (searchProduct.length >= 3) {
        setCityValue1([])
        dispatch(
          searchStaycationList({
            cityName: searchProduct.length > 0 ? searchProduct : '',
            search: searchProduct1.length > 0 ? searchProduct1 : ''
          })
        )
      }
    }, 1000)

    return () => {
      clearTimeout(timerId)
    }
  }, [searchProduct1, searchProduct])

  useEffect(() => {
    if ((!isFilter && cityName !== undefined) || selectedValue?.name === '') {
      if (name || cityName) {
        setSelectedValue({
          name: cityName !== undefined ? cityName : 'United Arab Emirates'
        })
        setSelectedValue1({
          name: name,
          _id: productId
        })
      } else {
        setSelectedValue({
          name: 'United Arab Emirates'
        })
        setSelectedValue1({
          name: ''
        })
      }

      // setFilterDataOne(obj);
      setCountryValue(country)
      // setCityValue(cityName);
      setCheckInDate(checkIn)
      setCheckOutDate(checkOut)
      setGuestValue({
        Adults: adult ? parseInt(adult) : 1,
        Children: child ? parseInt(child) : 0,
        Rooms: rooms ? parseInt(rooms) : 1
      })
      const obj = {
        StayCationId: productId,
        cityName: cityName ? cityName : 'United Arab Emirates',
        // name: name ? name : '',
        departDate: checkIn ? checkIn : '',
        returnDate: checkOut ? checkOut : '',
        priceRange: priceData,
        filter: activityType,
        "sort": sortData
      }
      setLoder(true)
      setHolidayListData([])
      clearPaginationValue()
      dispatch(getStaycationListNew(obj))
    } else if (isFilter) {
      // setFilterDataOne(obj);
      setCountryValue(country)
      // setCityValue(cityName);
      setCheckInDate(checkIn)
      setCheckOutDate(checkOut)
      setGuestValue({
        Adults: adult ? parseInt(adult) : 1,
        Children: child ? parseInt(child) : 0,
        Rooms: rooms ? parseInt(rooms) : 1
      })
      const obj = {
        StayCationId: selectedValue1?._id,
        cityName:
          selectedValue?.name !== undefined
            ? selectedValue?.name
            : 'United Arab Emirates',
        //  name: name ? name : '',
        departDate: checkIn ? checkIn : '',
        returnDate: checkOut ? checkOut : '',
        priceRange: priceData,
        filter: activityType,
        "sort": sortData
      }
      setLoder(true)
      setHolidayListData([])
      clearPaginationValue()
      dispatch(getStaycationListNew(obj))
    }
  }, [productId, cityName, activityType, filterDataOne?.type])

  const handleSearch = () => {
    const obj = {
      StayCationId: selectedValue1?._id,
      cityName:
        selectedValue?.name !== undefined
          ? selectedValue?.name
          : 'United Arab Emirates',
      // name: selectedValue?.name,
      departDate: checkIn ? checkIn : '',
      returnDate: checkOut ? checkOut : '',
      priceRange: priceData,
      filter: activityType,
      "sort": sortData
    }
    setLoder(true)
    setActiveSort("FEATURED");
    setSortOrder("asc");
    // setSortData(0);
    setHolidayListData([])
    clearPaginationValue()
    dispatch(getStaycationListNew(obj))
    dispatch(searchStaycationFilter(obj))
  }

  // useEffect(() => {
  //   if (priceData) {
  //     if (isPriceChange) {
  //       const obj = {
  //         StayCationId: selectedValue1?._id,
  //         cityName: selectedValue?.name,
  //         // name: selectedValue?.name,
  //         departDate: checkIn ? checkIn : '',
  //         returnDate: checkOut ? checkOut : '',
  //         priceRange: priceData,
  //         filter: activityType,
  //         "sort": sortData
  //       }
  //       setLoder(true)
  //       setHolidayListData([])  
  //       dispatch(getStaycationListNew(obj))
  //     }
  //   }
  // }, [priceData])

  useEffect(() => {
    if (sortData && sortData !== 0) {
      if (isPriceChange) {
        const obj = {
          StayCationId: selectedValue1?._id,
          cityName: selectedValue?.name,
          // name: selectedValue?.name,
          departDate: checkIn ? checkIn : '',
          returnDate: checkOut ? checkOut : '',
          priceRange: priceData,
          filter: activityType,
          "sort": sortData
        }
        setLoder(true)
        setHolidayListData([])
        clearPaginationValue()
        dispatch(getStaycationListNew(obj))
      }
    }
  }, [sortData])

  const handleClearFilter = () => {
    setPriceData(priceData1)
    setSortData(sortData)
    setActivityType([])
    const obj = {
      StayCationId: selectedValue1?._id,
      cityName: selectedValue?.name,
      // name: selectedValue?.name,
      departDate: checkIn ? checkIn : '',
      returnDate: checkOut ? checkOut : '',
      priceRange: priceData1,
      "sort": 0,
      filter: []
    }
    setSortData(0);
    setActiveSort("FEATURED");
    setSortOrder("asc");
    setLoder(true)
    setHolidayListData([])
    clearPaginationValue()
    dispatch(getStaycationListNew(obj))
  }

  const clearPaginationValue = () => {
    setPaginationData({
      page: 1,
      limit: 10
    });

    // ✅ Ensure scrolling resets after state updates
    setTimeout(() => {
      if (scrollableDivRef.current) {
        scrollableDivRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
        window.scrollTo({ top: 0, behavior: "smooth" });

      }
    }, 100);
  }

  useEffect(() => {
    if (stayCationListNew) {
      if (stayCationListNew?.stayCationList?.length > 0) {
        if (paginationData?.page > 1) {
          setHolidayListData(prev => [
            ...prev,
            ...stayCationListNew?.stayCationList
          ])
          setIsFetching(false)
        } else {
          setHolidayListData(stayCationListNew?.stayCationList)
          clearPaginationValue()
        }
        setLoder(false)
      } else {
        setHolidayListData([])
        setLoder(false)
      }
    }
  }, [stayCationListNew, selectedValue])

  const handleCurrency = () => {
    setClick(prevState => !prevState)
    // router.push("/sign-in/sign-in");
    sessionStorage.setItem('bookingPath', currentPath)
  }

  useEffect(() => {
    // if (staycationSearchRes.length > 0) {
    if (staycationSearchRes !== undefined) {
      // Create an empty object
      const myObjectDestination = {}
      const childArrayDestination = []
      const myObjectStaycationList = {}
      const childArrayStaycationList = []
      const allObjectDestination = {}
      const allArrayDestination = []
      const mainArray = []
      setCityLoading(false)
      setLoading(false)
      if (staycationSearchRes?.destination !== undefined) {
        if (staycationSearchRes?.destination.length > 0) {
          staycationSearchRes?.destination.map(data => {
            myObjectDestination.label = 'City'
            myObjectDestination.img = '/img/general/flag.png'
            childArrayDestination.push(data)
            myObjectDestination.values = childArrayDestination
            //
          })
        } else {
          myObjectDestination.label = 'City'
          myObjectDestination.values = []
        }
      }

      if (staycationSearchRes?.countryList !== undefined) {
        if (staycationSearchRes?.countryList.length > 0) {
          staycationSearchRes?.countryList.map(data => {
            myObjectStaycationList.label = 'Country'
            myObjectStaycationList.img = '/img/general/iconnew.png'
            childArrayStaycationList.push(data)
            myObjectStaycationList.values = childArrayStaycationList
            //
          })
        } else {
          myObjectStaycationList.label = 'Country'
          myObjectStaycationList.values = []
        }
      }

      if (staycationSearchRes?.allCityType !== undefined) {
        if (staycationSearchRes?.allCityType.length > 0) {
          staycationSearchRes?.allCityType.map(data => {
            allObjectDestination.label = data?.countryName || 'Matched Location'
            allObjectDestination.img = '/img/general/iconnew.png'
            allArrayDestination.push(data)
            allObjectDestination.values = allArrayDestination
            //
          })
        } else {
          allObjectDestination.label = 'Matched Location'
          allObjectDestination.values = []
        }
      }

      // setLoading(false);

      mainArray.push(
        allObjectDestination,
        myObjectDestination,
        myObjectStaycationList
      )
      setCityValue(mainArray)
    }
  }, [staycationSearchRes])

  useEffect(() => {
    // if (tourSearchRes.length > 0) {
    if (staycationSearchListRes !== undefined) {
      // Create an empty object
      const myObjectDestination = {}
      const childArrayDestination = []
      const myObjectHolidayList = {}
      const childArrayHolidayList = []
      const mainArray = []
      setLoading(false)
      if (staycationSearchListRes?.topAttraction !== undefined) {
        if (staycationSearchListRes?.topAttraction.length > 0) {
          staycationSearchListRes?.topAttraction.map(data => {
            myObjectDestination.label = 'Top Staycation'
            myObjectDestination.img = '/img/general/flag.png'
            childArrayDestination.push(data)
            myObjectDestination.values = childArrayDestination
            //
          })
        } else {
          myObjectDestination.label = 'Top Staycation'
          myObjectDestination.values = []
        }
      }

      if (staycationSearchListRes?.staycationList !== undefined) {
        if (staycationSearchListRes?.staycationList.length > 0) {
          staycationSearchListRes?.staycationList.map(data => {
            myObjectHolidayList.label = 'Staycation'
            myObjectHolidayList.img = '/img/general/iconnew.png'
            childArrayHolidayList.push(data)
            myObjectHolidayList.values = childArrayHolidayList
            //
          })
        } else {
          myObjectHolidayList.label = 'Staycation'
          myObjectHolidayList.values = []
        }
      }
      if (staycationSearchListRes.staycationList.length === 0) {
        setSelectedValue1({
          name: ''
        })
      }

      mainArray.push(myObjectDestination, myObjectHolidayList)
      setCityValue1(mainArray)
    }
  }, [staycationSearchListRes])

  useEffect(() => {
    // :white_check_mark: Check if there are no query parameters
    if (Object.keys(router.query).length === 0) {
      handleSearch()
    }
  }, [router.query])

  useEffect(() => {
    const offcanvasElement = document.getElementById('carSidebar')

    if (offcanvasElement) {
      offcanvasElement.addEventListener('shown.bs.offcanvas', () => {
        setIsOffcanvasOpen(true)
      })

      offcanvasElement.addEventListener('hidden.bs.offcanvas', () => {
        setIsOffcanvasOpen(false)
      })
    }
  }, [])



  return (
    <>
      <Seo meta={meta} />
      <Header3 isOffcanvasOpen={isOffcanvasOpen} />

      <div
        style={{
          backgroundColor: '#fcfcfc'
        }}
        className='listpage_margin_top'
      >
        <section
          className='m-auto rsl__Wrapper'
          style={{
            backgroundColor: '#fcfcfc'
          }}
        >
          {/* Book Cars */}
          <div
            className='main-area'
            style={{
              backgroundColor: '#fffff'
            }}
          >
            <div className='booking-area'>
              <div className='book-activities book-activities-new'>
                <div className='input-location'>
                  <HotelDestinationCity
                    setCityValue={setCityValue}
                    cityValue={cityValue}
                    searchProduct={searchProduct}
                    setSearchProduct={setSearchProduct}
                    setSelectedValue={setSelectedValue}
                    selectedValue={selectedValue}
                    setLoading={setCityLoading}
                    loading={cityLoading}
                    placeholder='Search'
                    label='City or Region'
                    autocompleteFirst={autocompleteFirst}
                    queryValue={cityName}
                  />
                </div>

                {/* <LocationSearch placeholder="Location" /> */}
                <ActivityListStaycation
                  setCityValue={setCityValue1}
                  cityValue={cityValue1}
                  searchProduct={searchProduct1}
                  setSearchProduct={setSearchProduct1}
                  setSelectedValue={setSelectedValue1}
                  selectedValue={selectedValue1}
                  setLoading={setLoading}
                  loading={loading}
                  placeholder='Search'
                  label='Staycaions'
                  autocompleteNext={autocompleteNext}
                />

                <div className='d-flex items-center justify-start'>
                  <div className='mr-md-15 mobile-btn'>
                    <button
                      className='text-26 text-white search-btn mobile-btn'
                      // onClick={() => {
                      //   setSerachBtn(true);
                      // }}
                      onClick={handleSearch}
                    >
                      <div className='icon-search'></div>
                    </button>
                  </div>
                </div>
                <div
                  id='offcanvasTop'
                  className='offcanvas input-style offcanvas-top items-center justify-center'
                >
                  <input
                    className='input-style'
                    placeholder='Search..'
                    type='search'
                  />
                </div>
              </div>
              <div className='horizontal-line'>
                <span className='circle left-circle'></span>
                <span className='circle right-circle'></span>
              </div>
            </div>
          </div>
        </section>
        {/* Booking Section Start */}
        <section className='booking-content-car rsl__Wrapper'>
          {/* Booking Content Start */}

          <div className='booking-contents'>
            {/* Left */}
            <Box
              className='col-xl-12 xl:p-3 custom-filter-scroll sticky-sidebar'
              sx={{
                // border: { xs: 'none', lg: '1px solid #dee2e6' },
                scrollbarWidth: 'none',
                height: '100%', // Ensure full height
                overflow: 'hidden' // Prevent extra scroll space
              }}
            >
              <aside className='sidebar rounded xl:d-none'>
                <CarSideBar
                  setFilterDataOne={setFilterDataOne}
                  filterDataOne={filterDataOne}
                  setLoder={setLoder}
                  filterData={filterData}
                  priceData={priceData}
                  setPriceData={setPriceData}
                  sortData={sortData}
                  setSortData={setSortData}
                  activityType={activityType}
                  setActivityType={setActivityType}
                  priceData1={priceData1}
                  setPriceData1={setPriceData1}
                  handleClearFilter={handleClearFilter}
                  setIsPriceChange={setIsPriceChange}
                  isPriceChange={isPriceChange}
                  setIsFilter={setIsFilter}
                  currency={currency}
                />
              </aside>
              {/* End sidebar for desktop */}

              <div
                className='offcanvas offcanvas-start'
                tabIndex='-1'
                id='carSidebar'
              >
                <div className='offcanvas-header'>
                  <h5 className='offcanvas-title' id='offcanvasLabel'>
                    Filter Rentals
                  </h5>

                  <button
                    type='button'
                    className='btn-close'
                    data-bs-dismiss='offcanvas'
                    aria-label='Close'
                  ></button>
                </div>
                {/* End offcanvas header */}

                <div
                  className='offcanvas-body'
                  style={{
                    height: '100vh',
                    display: 'flex',
                    flexDirection: 'column'
                  }}
                >
                  <aside
                    className='sidebar y-gap-40 xl:d-block'
                    style={{
                      height: '90vh',
                      display: 'flex',
                      flexDirection: 'column'
                    }}
                  >
                    {/* Scrollable ActivitiesSideBar */}
                    <div
                      className='y-gap-40'
                      style={{
                        flexGrow: 1,
                        overflowY: 'auto',
                        padding: '10px'
                      }}
                    >
                      <CarSideBar
                        setFilterDataOne={setFilterDataOne}
                        filterDataOne={filterDataOne}
                        setLoder={setLoder}
                        filterData={filterData}
                        priceData={priceData}
                        setPriceData={setPriceData}
                        activityType={activityType}
                        setActivityType={setActivityType}
                        priceData1={priceData1}
                        setSortData={setSortData}
                        setPriceData1={setPriceData1}
                        handleClearFilter={handleClearFilter}
                        setIsPriceChange={setIsPriceChange}
                        isPriceChange={isPriceChange}
                        setIsFilter={setIsFilter}
                        currency={currency}
                      />
                    </div>
                    {/* Fixed Apply Button at the bottom */}
                    <div
                      className='btn col-auto d-none xl:d-block'
                      style={{ padding: '10px', borderTop: '1px solid #ddd' }}
                    >
                      <button
                        data-bs-toggle='offcanvas'
                        data-bs-target='#carSidebar'
                        className='button -blue-1 h-40 px-20 rounded-100 bg-blue-1-05 text-15 text-white'
                      >
                        Apply
                      </button>
                    </div>
                  </aside>
                </div>
                {/* End offcanvas body */}
              </div>
              {/* End mobile menu sidebar */}

              {/* End mobile menu sidebar */}
            </Box>

            {/* Right */}
            <div className='activity-booking__cards'>
              {/* Menu */}
              <div className='cars-header d-none xl:d-flex justify-end mb-3'>
                <div className='btn col-auto'>
                  <button
                    data-bs-toggle='offcanvas'
                    data-bs-target='#carSidebar'
                    className='button -blue-1 h-40 px-20 rounded-100 bg-blue-1-05 text-15 text-white'
                  >
                    <i className='icon-up-down text-14 mr-10' />
                    Filter
                  </button>
                </div>
              </div>
              {/* card */}
              {holidayListData ? (
                <p
                  style={{
                    fontSize: '12px',
                    color: '#0c0c0c'
                  }}
                >{`Showing ${holidayListData?.length} of ${holidayListData?.length} staycation found`}</p>
              ) : (
                ''
              )}
              <div style={{ marginBottom: '10px' }} className='border rounded'>
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    backgroundColor: '#fff',
                    borderRadius: '4px'
                    // boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                  }}
                >
                  <div
                    style={{
                      padding: '10px 20px',
                      borderRight: '1px solid #e0e0e0',
                      cursor: 'pointer',
                      fontWeight: 'bold'
                    }}
                  >
                    SORT BY
                  </div>
                  <div
                    onClick={() => handleSortChange('RATING')}
                    style={{
                      padding: '10px 20px',
                      borderRight: '1px solid #e0e0e0',
                      cursor: 'pointer',
                      color: activeSort === 'RATING' ? '#6dc8bf' : 'black',
                      flex: 1,
                      textAlign: 'center'
                    }}
                  >
                    RATING{' '}
                    {activeSort === 'RATING' &&
                      (sortOrder === 'asc' ? '↓' : '↑')}
                  </div>
                  <div
                    onClick={() => handleSortChange('PRICE')}
                    style={{
                      padding: '10px 20px',
                      cursor: 'pointer',
                      color: activeSort === 'PRICE' ? '#6dc8bf' : 'black',
                      flex: 1,
                      textAlign: 'center'
                    }}
                  >
                    PRICE{' '}
                    {activeSort === 'PRICE' &&
                      (sortOrder === 'asc' ? '↓' : '↑')}
                  </div>
                </div>
              </div>
              <div className='col-xl-12 rounded' ref={scrollableDivRef}>
                {loader ? (
                  <>
                    <div className='d-flex flex-column'>
                      {[1, 2, 3, 4, 5].map(index => (
                        <div className='border p-3 rounded mb-3' key={index}>
                          <div className='car-main__section'>
                            <div className='car-main__section_in'>
                              <div className='car-main__image'>
                                <Skeleton
                                  animation='wave'
                                  variant='rectangular'
                                  width={200}
                                  height={200}
                                />
                              </div>
                              <div>
                                <Skeleton
                                  animation='wave'
                                  variant='rectangular'
                                  width={180}
                                  height={20}
                                />

                                <div className='my-3'>
                                  <h6>
                                    <Skeleton
                                      animation='wave'
                                      variant='rectangular'
                                      width={160}
                                      height={20}
                                    />
                                  </h6>
                                </div>

                                <div className='mt-3'>
                                  <h6 className='text-info'>
                                    {' '}
                                    <Skeleton
                                      animation='wave'
                                      variant='rectangular'
                                      width={80}
                                      height={10}
                                    />
                                  </h6>
                                </div>
                              </div>
                            </div>
                            <div className='d-flex align-items-end flex-sm-row flex-md-column justify-content-between'>
                              <div>
                                <Skeleton
                                  animation='wave'
                                  variant='rectangular'
                                  width={80}
                                  height={20}
                                />
                              </div>
                              <div className='d-flex flex-column align-items-end'>
                                <div className='trip-btns'>
                                  <Skeleton
                                    animation='wave'
                                    variant='rectangular'
                                    width={120}
                                    height={30}
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                    {/* Popup with animation */}
                    {/* <div className='popup-overlay'>
                      <div className='popup-content'>
                        <div className='popup'>
                          <Player
                            src='/img/icons/staycationList.json'
                            className='player'
                            loop
                            autoplay
                          />
                        </div>
                        <h5
                          style={{
                            padding: '20px 0px',
                            width: '100%',
                            backgroundColor: '#f4f6ff',
                            borderRadius: '10px'
                          }}
                        >
                          Hold on, We&apos;re fetching best staycations for you.
                        </h5>
                      </div>
                    </div> */}
                  </>
                ) : !holidayListData || holidayListData?.length === 0 ? (
                  <div className='no-data text-center pt-30'>
                    <div>
                      <img
                        src='/img/icons/noresults.png'
                        width='200'
                        height='200'
                      />
                      <p>No suitable staycations found</p>
                      {/* <p>Try modifying the City or Area</p> */}
                    </div>
                  </div>
                ) : (
                  <div className='activity-list'>
                    {holidayListData &&
                      holidayListData.length !== 0 &&
                      holidayListData?.map((item, index) => {
                        const isLastItem = index === holidayListData.length - 5 // ✅ Detect last item
                        return (
                          <div
                            key={index}
                            className='border rounded mb-3'
                            style={{ overflow: 'hidden' }}
                          >
                            <div className='car-main__section'>
                              <div
                                className='car-main__section_in'
                                style={{ cursor: 'pointer' }}
                                onClick={() => {
                                  setCurrentButton(index)
                                  item?.availability === 'not available' ||
                                    item?.isAvailable === false
                                    ? ''
                                    : window.open(
                                      `/staycation/staycation-details?${new URLSearchParams(
                                        {
                                          _id: item._id,
                                          country: countryValue,
                                          city: cityValue,
                                          checkIn: checkInDate,
                                          checkOut: checkOutDate,
                                          adult: guetsValue.Adults,
                                          child: guetsValue.Children,
                                          room: guetsValue.Rooms
                                        }
                                      )}`,
                                      '_blank'
                                    )
                                }}
                              >
                                <div
                                  className='car-main__image'
                                  style={{
                                    overflow: 'hidden',
                                    display: 'inline-block'
                                  }}
                                >
                                  <Image
                                    width={200}
                                    height={200}
                                    className='main-car__img'
                                    src={`${process.env.IMAGE_BASE_URL}/${item?.packageImage}`}
                                    alt='car'
                                    style={{
                                      transition: 'transform 0.3s ease-in-out',
                                      objectFit: 'cover', // ✅ Keeps image properly fitted
                                      width: '100%', // ✅ Fills the container properly
                                      height: '100%'
                                    }}
                                    onMouseOver={e =>
                                    (e.currentTarget.style.transform =
                                      'scale(1.1)')
                                    }
                                    onMouseOut={e =>
                                    (e.currentTarget.style.transform =
                                      'scale(1)')
                                    }
                                  />
                                </div>
                                <div className='p-3'>
                                  <div
                                    className={`d-flex items-center ${item?.totalNights
                                      ? 'justify-between'
                                      : 'justify-end'
                                      } `}
                                  >
                                    <div>
                                      {item?.totalNights && (
                                        <span className='-dark-4  px-5 py-1 rounded-1 bg-dark-2 text-white car-main__label'>
                                          {item?.totalNights}
                                        </span>
                                      )}
                                      {item?.rating && (
                                        <span
                                          className='ml-5 px-3 py-1 d-inline-flex align-items-center'
                                          style={{
                                            background: 'rgb(224, 221, 221)',
                                            borderRadius: '15px',
                                            color: 'rgb(23, 32, 76)',
                                            fontWeight: 'bold',
                                            fontSize: '12px'
                                          }}
                                        >
                                          {item?.rating}
                                          <span
                                            style={{
                                              marginLeft: '3px',
                                              color: 'rgb(18, 51, 25)',
                                              fontSize: '12px'
                                            }}
                                          >
                                            ★
                                          </span>
                                        </span>
                                      )}
                                    </div>
                                    {item?.availability !== 'not available' && (
                                      <CallMadeIcon className='border mx-1 rounded d-md-none' />
                                    )}
                                  </div>

                                  <div className='my-2'>
                                    <h6>
                                      {item?.packageName}
                                      <span className='main-car__p ml-5'>
                                        {item.totalNights}
                                      </span>
                                    </h6>
                                    <p className='main-car__p d-none d-md-flex'>
                                      {item?.description.slice(0, 50)}
                                    </p>

                                    <div className='staycation-price d-md-none'>
                                      <div className='staycation-price'>
                                        <div className='price'>
                                          <span
                                            className='font-weight-light'
                                            style={{
                                              fontSize: '14px',
                                              color: 'black',
                                              fontWeight: 'lighter',
                                              marginRight: '8px'
                                            }}
                                          >
                                            From
                                          </span>
                                          {item?.currency &&
                                            item?.currency !== ''
                                            ? item?.currency.toUpperCase()
                                            : item?.currency}{' '}
                                          {item?.price?.toFixed(2)}{' '}
                                        </div>
                                        {Number(item?.originalPrice) >
                                          Number(item?.price) && (
                                            <span className='price-strike'>
                                              {item?.currency &&
                                                item?.currency !== ''
                                                ? item?.currency.toUpperCase()
                                                : item?.currency}{' '}
                                              {Number(item?.originalPrice)}
                                            </span>
                                          )}

                                        <div>
                                          <span
                                            style={{
                                              fontSize: '14px',
                                              color: '#808080',
                                              fontWeight: 'lighter'
                                            }}
                                          >
                                            {item?.priceDescription}
                                          </span>
                                        </div>
                                      </div>
                                    </div>
                                  </div>

                                  <div className='mt-3'>
                                    <h6 className='text-info'>
                                      {item?.cityName}
                                    </h6>
                                  </div>
                                </div>
                              </div>

                              <div className='d-none d-md-flex align-items-end flex-sm-row flex-md-column justify-content-between p-3'>
                                <div className='staycation-price'>
                                  <div className='price'>
                                    <span
                                      className='font-weight-light'
                                      style={{
                                        fontSize: '14px',
                                        color: 'black',
                                        fontWeight: 'lighter',
                                        marginRight: '8px'
                                      }}
                                    >
                                      From
                                    </span>
                                    {item?.currency && item?.currency !== ''
                                      ? item?.currency.toUpperCase()
                                      : item?.currency}{' '}
                                    {item?.price.toFixed(2)}{' '}
                                  </div>

                                  {Number(item?.originalPrice) >
                                    Number(item?.price) && (
                                      <span className='price-strike'>
                                        {item?.currency}{' '}
                                        {Number(item?.originalPrice)}
                                      </span>
                                    )}

                                  <div
                                    style={{
                                      textAlign: 'end'
                                    }}
                                  >
                                    <span
                                      style={{
                                        fontSize: '14px',
                                        color: '#808080',
                                        fontWeight: 'lighter'
                                      }}
                                    >
                                      {item?.priceDescription}
                                    </span>
                                  </div>
                                </div>

                                <div className='d-flex flex-column align-items-end'>
                                  {item?.availability !== 'not available' &&
                                    item?.isAvailable ? (
                                    <div className='trip-btns'>
                                      <a
                                        style={{
                                          cursor: 'pointer'
                                        }}
                                        className='trip-btn button -dark-4 px-30 py-5 bg-dark-3 text-white'
                                        onClick={() => {
                                          setCurrentButton(index)
                                          item?.availability ===
                                            'not available' ||
                                            item?.isAvailable === false
                                            ? ''
                                            : window.open(
                                              `/staycation/staycation-details?${new URLSearchParams(
                                                {
                                                  _id: item._id,
                                                  country: countryValue,
                                                  city: cityValue,
                                                  checkIn: checkInDate,
                                                  checkOut: checkOutDate,
                                                  adult: guetsValue.Adults,
                                                  child: guetsValue.Children,
                                                  room: guetsValue.Rooms
                                                }
                                              )}`,
                                              '_blank'
                                            )
                                        }}
                                      >
                                        View Deal
                                      </a>
                                    </div>
                                  ) : (
                                    <div>
                                      <p
                                        style={{
                                          color:
                                            item?.availability !==
                                              'not available' &&
                                              item?.isAvailable
                                              ? 'green'
                                              : 'red'
                                        }}
                                      >
                                        {item?.availability !==
                                          'not available' && item?.isAvailable
                                          ? 'AVAILABLE'
                                          : 'Fully Booked'}
                                      </p>
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>
                            {/* ✅ Attach `ref` to the last item */}
                            {isLastItem && (
                              <div
                                ref={lastItemRef}
                                className='text-center mt-3'
                              ></div>
                            )}
                          </div>
                        )
                      })}
                    {isFetching && (
                      <div className='d-flex justify-content-center align-items-center my-3'>
                        <CircularProgress size={40} sx={{ color: '#000000' }} />
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>
        </section>
        {/* --------------------- */}
      </div>
      <Footer3 />
    </>
  )
}

export default HolidaysBooking;

export async function getServerSideProps(context) {
  const rawPath = context.resolvedUrl;
  let path = rawPath.split("?")[0];
  if (path.length > 1 && path.endsWith("/")) {
    path = path.slice(0, -1);
  }
  const metaHome = await fetchSeoByPage(path);
  return {
    props: { meta: metaHome }
  };
}